import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import '@shopify/polaris/styles.css';
import {AppProvider, Spinner} from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import { initApp } from 'modules/shopify';
import {getUser} from 'api/user';

import App from 'components/App';

function WrappedApp() {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const app = initApp();
    if (!app) {
      setError('This app must be opened from the Shopify admin.');
      return;
    }
    getUser()
      .then(() => setReady(true))
      .catch(() => setReady(true));
  }, []);

  if (error) {
    return (
      <AppProvider i18n={enTranslations}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <p>{error}</p>
        </div>
      </AppProvider>
    );
  }

  if (!ready) {
    return (
      <AppProvider i18n={enTranslations}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <Spinner size="large" />
        </div>
      </AppProvider>
    );
  }

  return (
    <AppProvider i18n={enTranslations}>
      <App />
    </AppProvider>
  );
}

ReactDOM.render(<WrappedApp />, document.getElementById('root'));
